import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type FastApiService from 'walden-fast/services/fast-api';
import type {
  PaginatedResponse,
  PaginationQueryParams,
  SortingQueryParams,
} from 'walden-fast/types/pagination';
import type { Ticket } from 'walden-fast/types/ticket';
import { getSortingParams } from 'walden-fast/utils/sorting';

type Resolved<P> = P extends Promise<infer T> ? T : P;
export type AppContactIndexModel = Resolved<
  ReturnType<AppContactIndexRoute['model']>
>;

type AppContactIndexRouteQueryParams = SortingQueryParams &
  PaginationQueryParams;

export default class AppContactIndexRoute extends Route {
  @service('fast-api') declare fastApiService: FastApiService;

  queryParams = {
    page: {
      refreshModel: true,
    },
    pageSize: {
      refreshModel: true,
    },
    sortField: {
      refreshModel: true,
    },
    sortDirection: {
      refreshModel: true,
    },
  };

  async model(params: AppContactIndexRouteQueryParams) {
    const response = await this.fastApiService.get<PaginatedResponse<Ticket>>(
      `/contact/tickets`,
      {
        page: params.page || 1,
        pageSize: params.pageSize || 10,
        ...getSortingParams(params),
      },
    );
    if (!response) {
      throw new Error(`No tickets returned from API`);
    }
    return {
      tickets: response,
    };
  }
}
